import React, { useContext, useEffect, useState } from "react";
import { URL } from "../../config";
import Spinner from "../../assets/WeblandSpinner";
import { useHistory } from "react-router-dom";
import { AiFillEdit , FaPencilAlt} from "react-icons/ai";
import "./ProfileTransformer.css";
import { Link } from 'react-router-dom'; 



import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LinearScale,
  BarElement,
  CategoryScale,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { AiFillHome, AiOutlineMinusSquare } from "react-icons/ai";
import { MdOutlineAddBox, MdOutlineMinusBox, MdOutlineWarehouse, MdOutlineReadMore } from "react-icons/md";
import { RiContactsLine } from "react-icons/ri";
import { AuthContext } from "../AuthContext";
import AddBolotaModal from "../Mobile/AddBolotaModal";
import EditBolotaModal from "../Mobile/EditBolotaModal";
import { Bar } from 'react-chartjs-2';



ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  LinearScale,
  BarElement,
  CategoryScale
);



function ProducerLayout() {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const [produtorData, setProdutorData] = useState({});
  const [producerId, setProducerId] = useState(null);
  const [, dashboard, , type] = history.location.pathname.split("/");
  const { token } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editedProduct, setEditedProduct] = useState({});
  const [idProducer, setIdProducer] = useState(null);
  const [unitType, setUnitType] = useState("processos");

  const [orders, setOrders] = useState([]); // Estado para armazenar as encomendas
  const transformerId = localStorage._id;

  const fetchProducerData = (id) => {
    fetch(`${URL}/webland-api/transformer/${localStorage.id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("API Response:", data); // Adicione esta linha
    
      setProdutorData(data);
      
    }).catch((error) => {
        console.error("Error fetching producer data:", error);
      });
  };
 


  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const idFromURL = localStorage.id;
    console.log("localStorage",localStorage)
    const emailFromURL = urlParams.get("email");

    const fetchIdByEmail = async (email) => {
      try {
        const response = await fetch(`${URL}/webland-api/transformer/idByEmail/${email}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        if (response.ok) {
          const data = await response.json();
          setIdProducer(data.id);
        } else {
          console.error("Falha ao buscar os dados do usuário");
        }
      } catch (error) {
        console.error("Erro ao buscar os dados do usuário:", error);
      }
    };

    if (emailFromURL) {
      fetchIdByEmail(emailFromURL);
    }
    if (idFromURL) {
      setProducerId(idFromURL);
      fetchProducerData(idFromURL);
    }

    const fetchOrders = async () => {
      try {
        const response = await fetch(`${URL}/webland-api/transformador/${transformerId}`);
        if (!response.ok) {
          throw new Error("Erro ao buscar encomendas");
        }
        const data = await response.json();

        // Filtra apenas as encomendas com status "finished"
        const filteredOrders = data.filter((order) => order.status === "finished");
        setOrders(filteredOrders);
      } catch (error) {
        console.error("Erro ao buscar encomendas:", error);
      }
    };

    fetchOrders();
  }, [transformerId]);

  useEffect(() => {
    const idFromURL = localStorage.id;
    if (idFromURL) {
      setProducerId(idFromURL);
      fetchProducerData(idFromURL);
    }
  }, []);

  const handleModalClose = () => {
    setShowModal(false);
    setIsEditing(false);
    fetchProducerData(producerId || idProducer);
  };

  const { stockBolota, warehouseHistory } = produtorData;

  
  const barChartData = {
    labels: [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ],
    datasets: [
      { label: "Processos Realizados", data: [] },
      { label: "Quantidade (kg)", data: [] },
    ],
  };
  const staticData = [
    { name: "Encomenda 1", address: "Produtor A", region: "Zona 1", species: "29/05/2024",  status: "Concluido", processoAtual: "Concluido", produtoFinal: "Produto A"},
    { name: "Encomenda 2", address: "Produtor B", region: "Zona 2", species: "29/05/2024",  status: "Concluido",processoAtual: "Concluido", produtoFinal: "Produto A"},
    { name: "Encomenda 3", address: "Produtor C", region: "Zona 3", species: "29/05/2024",  status: "Concluido",processoAtual: "Concluido", produtoFinal: "Produto A"},
    { name: "Encomenda 4", address: "Produtor D", region: "Zona 4", species: "29/05/2024",  status: "Concluido" ,processoAtual: "Concluido", produtoFinal: "Produto A"},
    { name: "Encomenda 5", address: "Produtor E", region: "Zona 5", species: "29/05/2024",  status: "Concluido" ,processoAtual: "Concluido", produtoFinal: "Produto A"},
  ];


  return isLoading ? (
    <Spinner />
  ) : (
    <div className="producer-metrics-container">
   
      <div className="breadcrumb-container">
        <div className="MODELO"  style={{width: "60%"}}>
          <ProducerInfo produtorData={produtorData} />
          <br></br>
        </div>
    
        <div className="MODELO"   style={{width: "60%"}}>
        <div className="card producer-info-card" style={{width: "90%"}}>
       <div className="card-body" style={{width: "100%"}}>
        <h5 className="card-title"> Materias Primas Transformadas</h5>
        {barChartData.datasets.every(dataset => dataset.data.length === 0) ? (
        <p style={{ textAlign: "center", color: "#5D643F" }}>
          Ainda sem dados para mostrar
        </p>
      ) : (
        <Bar data={barChartData} />
      )}

       </div>
       </div>
       </div>
       </div>
  <div className="tables-container-encomendas">
          <div className="col-md-12 card-table-encomendas">
            <div className="card-header">
              <div  className="card-title">Últimas Encomendas Concluídas</div>
              <Link to={`/transformer/encomendasTransformer?id=${localStorage.id}`}>
          <button className="btn-load-more">
            Ver Mais
          </button>
        </Link>
            </div>
            <div className="card-table-body">
            {orders.length === 0 ? (
            <p style={{ textAlign: "center", color: "#5D643F" }}>
              Sem dados para mostrar
            </p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th className="table-header-cell">Encomenda</th>
                  <th className="table-header-cell">Produtor</th>
                  <th className="table-header-cell">Morada do Produtor</th>
                  <th className="table-header-cell">Data de Entrega</th>
                  <th className="table-header-cell">Estado</th>
                  <th className="table-header-cell">Processo Atual</th>
                  <th className="table-header-cell">Produto Final</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order, index) => (
                  <tr key={index}>
                    <td className="table-cell-nome">{order._id}</td>
                    <td className="table-cell">{order.producerName || "N/A"}</td>
                    <td className="table-cell">{order.producerAddress || "N/A"}</td>
                    <td className="table-cell">{order.deliveryDate || "N/A"}</td>
                    <td className="table-cell">{order.status}</td>
                    <td className="table-cell">{order.currentProcess || "N/A"}</td>
                    <td className="table-cell">{order.finalProduct || "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
            </div>
          </div>
          </div>
      </div>
    
  );
}

const Breadcrumb = ({ producerId, dashboard }) => {
  const history = useHistory();

  const navigateTo = (path) => {
    history.push(path);
  };


  return (
    <div className="breadcrumb-wrapper">
      <span className="breadcrumb-item" onClick={() => navigateTo('/dashboard')}>
        {dashboard ? dashboard.toUpperCase() : 'DASHBOARD'}
      </span>
      <span> &gt; </span>
      <span className="breadcrumb-item" onClick={() => navigateTo('/dashboard/produtores')}>
        Produtores
      </span>
      <span> &gt; </span>
      <span className="breadcrumb-item">
        {producerId}
      </span>
    </div>
  );
};
const formatAcornType = (type) => {
  return type
    .replace(/_/g, ' ') // Substitui os underscores por espaços
    .replace(/^\w/, (c) => c.toUpperCase()); // Converte a primeira letra para maiúscula
};


const ProducerInfo = ({ produtorData }) => {
    const history = useHistory();

  
  const { nif, email, phoneNumber, address, region, lat, long, createdAt, city } = produtorData;
  const navigateToEdit = (path) => {
    history.push(path);
  };
  const [isHovered, setIsHovered] = useState(false);


  return (
    <div className="card producer-info-card">
      <div className="card-body">
        <h5 className="card-title"> Informação do Transformador</h5>
        <div className="row">
        <div className="col-md-9 teste">
        <p><strong>Nome:</strong> {produtorData.name}</p>
        <p><strong>NIF:</strong> {nif}</p>
        <p><strong>Email:</strong> {email}</p>
        <p><strong>Telefone:</strong> {phoneNumber}</p>
        <p><strong>Morada:</strong> {city}</p>
        <p><strong>Zona:</strong> {region}</p>
        <p><strong>Latitude:</strong> {lat}</p>
        <p><strong>Longitude:</strong> {long}</p>
        <p><strong>Data de criação:</strong> {new Date(createdAt).toLocaleDateString()}</p>
         {/* Verificando se 'species' é uma string e convertendo em array */}
     
        </div>
        <div className="col-md-1">     <AiFillEdit 
        size={30} 
        style={{ color: isHovered ? 'var(--focus-color)' : 'var(--primary-color)', cursor: 'pointer' }}
        onClick={() => window.location.href = `/editusers?id=${localStorage.userId}`}  // Atualize para a rota desejada
      />
             </div>
    </div>
   
      </div>
   
    </div>
    
  );
};







export default ProducerLayout;
